var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCilSchool({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9688 17.1212L12.5 20.1974L7.03125 17.1212V13.8711L5.46875 13.0031V18.035L12.5 21.9901L19.5312 18.035V13.0031L17.9688 13.8711V17.1212Z",
    fill: "#F8F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.245L1.5625 7.91628V9.27048L12.5 15.3467L21.875 10.1385V14.4531H23.4375V7.91628L12.5 2.245ZM20.3125 9.21916L18.75 10.0872L12.5 13.5596L6.25 10.0872L4.6875 9.21916L3.60454 8.6175L12.5 4.00505L21.3955 8.6175L20.3125 9.21916Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCilSchool);
export default __webpack_public_path__ + "static/media/cil_school.252ff1b1db7df4d4eb7bc0e89d11ee8c.svg";
export { ForwardRef as ReactComponent };